import dayjs from 'dayjs'
import { CustomerJourney } from '@/modules/Customer/types'
import { ExpectedDateStatus, JourneyOutcome } from './types'

export const getExpectedDateStatus = (
    expectedDate: string | null | undefined
): ExpectedDateStatus => {
    if (!expectedDate)
        return {
            status: 'none',
            daysLeft: null,
            isWarning: false,
            isOverdue: false,
        }

    const now = dayjs()
    const expected = dayjs(expectedDate)
    const daysLeft = expected.diff(now, 'day')

    if (daysLeft < 0) {
        return {
            status: 'overdue',
            daysLeft: Math.abs(daysLeft),
            isWarning: true,
            isOverdue: true,
        }
    } else if (daysLeft <= 30) {
        return {
            status: 'approaching',
            daysLeft,
            isWarning: true,
            isOverdue: false,
        }
    }

    return { status: 'normal', daysLeft, isWarning: false, isOverdue: false }
}

export const getJourneyOutcome = (journey: CustomerJourney): JourneyOutcome => {
    if (!journey.customer_journey_locked) return 'active'
    if (
        journey.customer_journey_step === 'close_win' ||
        (journey.customer_journey_step === 'contract' &&
            journey.customer_journey_step_status === 'completed')
    ) {
        return 'won'
    }
    if (journey.customer_journey_step === 'terminate') return 'terminated'
    if (journey.customer_journey_step === 'close_lose') return 'lost'
    return 'lost'
}

export const isSystemNote = (noteContent: string): boolean => {
    if (!noteContent) return false
    const systemPatterns = [
        /^Chuyển sang bước/i,
        /^Chuyển từ .+ sang/i,
        /^Moved to step/i,
        /^Moved from .+ to/i,
        /^Step changed to/i,
        /^Hoàn thành quá trình/i,
        /^Journey completed/i,
        /^Mở lại từ/i,
        /^Re-engaged from/i,
        /^Đóng deal/i,
        /^Deal closed/i,
        /^Tạo POC/i,
        /^POC created/i,
        /^Tạo hợp đồng/i,
        /^Contract created/i,
        /^step-changed-to/i,
    ]
    return systemPatterns.some((pattern) => pattern.test(noteContent.trim()))
}
